<ndt-account-log-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [systemLogPrivileges]="systemLogPrivileges$ | async"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
   (openDialog)="onOpenDialog($event)"
   (openLogDialog)="onOpenLogDialog($event)"
></ndt-account-log-register-view>
